AFRAME.registerComponent('watchlist-notification-popup', {
    init: function() {
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setup: function(options) {
        this.options = options || {};
    },

    open: function() {
        this.render();
    },

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // Background
        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 1.43);
        bg.setAttribute('height', 0.5);
        bg.setAttribute('position', '-0.715 -0.25 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        // Title
        const titleText = document.createElement('a-troika-text');
        titleText.setAttribute('value', this.options.title || 'Notification');
        titleText.setAttribute('font-size', 0.045);
        titleText.setAttribute('color', txtColor);
        titleText.setAttribute('position', '0 0.16 0.01');
        titleText.setAttribute('anchor', 'center');
        this.el.appendChild(titleText);

        // Content
        const contentText = document.createElement('a-troika-text');
        contentText.setAttribute('value', this.options.content || '');
        contentText.setAttribute('font-size', 0.035);
        contentText.setAttribute('color', '#AAA');
        contentText.setAttribute('position', '0 0.05 0.01');
        contentText.setAttribute('max-width', 1.3);
        contentText.setAttribute('anchor', 'center');
        contentText.setAttribute('align', 'center');
        this.el.appendChild(contentText);

        // OK Button
        const okBtn = document.createElement('a-entity');
        okBtn.setAttribute('position', '0 -0.15 0.02');
        okBtn.setAttribute('ui-button', {
            label: this.options.buttonText || 'OK',
            width: 0.35,
            height: 0.08,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        okBtn.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('watchlist-notification-vr-popup'));
        this.el.appendChild(okBtn);
    }
});
